module.exports = __webpack_public_path__ + "static/ledger.a93cecff.png";


//////////////////
// WEBPACK FOOTER
// /Users/grantmaclennan/code/_archive/Toos/src/images/ledger.png
// module id = 177
// module chunks = 0